export default "__VITE_ASSET__049243c5__"